import {registerRoute as workbox_routing_registerRoute} from 'D:/Code/Windows/Excel/TreeSheets2/node_modules/workbox-routing/registerRoute.mjs';
import {ExpirationPlugin as workbox_expiration_ExpirationPlugin} from 'D:/Code/Windows/Excel/TreeSheets2/node_modules/workbox-expiration/ExpirationPlugin.mjs';
import {CacheableResponsePlugin as workbox_cacheable_response_CacheableResponsePlugin} from 'D:/Code/Windows/Excel/TreeSheets2/node_modules/workbox-cacheable-response/CacheableResponsePlugin.mjs';
import {CacheFirst as workbox_strategies_CacheFirst} from 'D:/Code/Windows/Excel/TreeSheets2/node_modules/workbox-strategies/CacheFirst.mjs';
import {clientsClaim as workbox_core_clientsClaim} from 'D:/Code/Windows/Excel/TreeSheets2/node_modules/workbox-core/clientsClaim.mjs';
import {precacheAndRoute as workbox_precaching_precacheAndRoute} from 'D:/Code/Windows/Excel/TreeSheets2/node_modules/workbox-precaching/precacheAndRoute.mjs';/**
 * Welcome to your Workbox-powered service worker!
 *
 * You'll need to register this file in your web app.
 * See https://goo.gl/nhQhGp
 *
 * The rest of the code is auto-generated. Please don't update this file
 * directly; instead, make changes to your Workbox build configuration
 * and re-run your build process.
 * See https://goo.gl/2aRDsh
 */








self.skipWaiting();

workbox_core_clientsClaim();


/**
 * The precacheAndRoute() method efficiently caches and responds to
 * requests for URLs in the manifest.
 * See https://goo.gl/S9QRab
 */
workbox_precaching_precacheAndRoute([
  {
    "url": "assets/icon-128.png",
    "revision": "d625f22fd057ab7aeaf20e86005a7f36"
  },
  {
    "url": "assets/icon-16.png",
    "revision": "36865c5da10bb9074fd0126eba412ec3"
  },
  {
    "url": "assets/icon-32.png",
    "revision": "2ce89e7f84249e0bdcb0275e9171db3c"
  },
  {
    "url": "assets/icon-64.png",
    "revision": "72da4c11636df23bd43810af5eae3769"
  },
  {
    "url": "assets/icon-80.png",
    "revision": "a9965a5aaa8a2d723e73c25e2535c07f"
  },
  {
    "url": "assets/logo-filled.png",
    "revision": "ef07e92aa42d1d6b18d10c979f1495d3"
  },
  {
    "url": "manifest.xml",
    "revision": "08077d2cfbc72c96225480efeef5607a"
  },
  {
    "url": "polyfill.bundle.js",
    "revision": "857ca37a677d493b814e3c3874484e74"
  },
  {
    "url": "runtime.bundle.js",
    "revision": "46a840fb280d4ac5d9cace15f2aca2d7"
  },
  {
    "url": "style.css",
    "revision": "c95a94f6210022ad2a33627adfc04009"
  },
  {
    "url": "taskpane.bundle.js",
    "revision": "edb8959f17ed16f1e05c8ccd6fc9dda5"
  },
  {
    "url": "taskpane.html",
    "revision": "60a07ca3863c57ceba80ef2544f421cc"
  }
], {});




workbox_routing_registerRoute(/\.(?:png|jpg|jpeg|svg|css|js|html)$/, new workbox_strategies_CacheFirst({ "cacheName":"static-assets","matchOptions":{"ignoreVary":true}, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 50 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');
workbox_routing_registerRoute(/^https?:\/\/.*\.(css|js)$/, new workbox_strategies_CacheFirst({ "cacheName":"external-assets-cache","matchOptions":{"ignoreVary":true}, plugins: [new workbox_expiration_ExpirationPlugin({ maxEntries: 50, maxAgeSeconds: 604800 }), new workbox_cacheable_response_CacheableResponsePlugin({ statuses: [ 0, 200 ] })] }), 'GET');




